import { Component, Input, OnInit } from '@angular/core';
import { BalanceItemModel, BalanceItemPaymentStatus } from '../../models/liability-data.model';
import { ConnectedPosition } from '@angular/cdk/overlay';

@Component({
  selector: 'app-liability-info',
  templateUrl: './liability-info.component.html',
  styleUrls: ['./liability-info.component.css']
})
export class LiabilityInfoComponent implements OnInit {
  BalanceItemPaymentStatus = BalanceItemPaymentStatus;
  @Input() liability: BalanceItemModel;
  tooltipVisible = false;
  tooltipPositions: ConnectedPosition[] = [
    {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'top'
    }
  ];

  constructor() {}

  ngOnInit(): void {}
}
